"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
var colors = {
  primaryGreen: '#C5DA00',
  primaryGreenHover: '#90A900',
  primaryBlue: '#0F3E49',
  secondaryGreen: '#545F54',
  lilac: '#2D0028',
  bg1: '#FFFFFF',
  bg2: '#FAFAFA',
  bg3: '#F6F7F5',
  black: '#000000',
  buttonBlack: '#333333',
  black80: 'rgba(0,0,0,0.80)',
  black67: 'rgba(0,0,0,0.67)',
  black47: 'rgba(0,0,0,0.47)',
  white95: 'rgba(255, 255, 255, 0.95)',
  white80: 'rgba(255, 255, 255, 0.80)',
  white65: 'rgba(255, 255, 255, 0.65)',
  minorGreen: '#9BA08C',
  grey: '#848C84',
  spaceGrey: '#CDD0CD',
  spaceGreyB: '#DBDDDB',
  pink: '#D9B69D',
  softPink: '#F7F1ED',
  softGreen: '#DCDDCD',
  secondaryBlue: '#B7BFC0',
  softBlue: '#CED9DC',
  dataGrey: '#E6E6E6',
  boxOutline: '#4685FF',
  errorRed: '#BC0000',
  softRed: '#F7D5D5'
};
exports.colors = colors;